/// <amd-module name="Artifacts/Connect/services/ToolService" />
import { ICombinedFeedView } from "Artifacts/Connect/types/ICombinedFeedView";
import { ITool } from "Artifacts/Connect/types/ITool";
import { IVssPageContext } from "VSS/Platform/Context";
import { IPageData, IVssPageService } from "VSS/Platform/Page";

interface IToolService {
  getAvailableTools(
    pageContext: IVssPageContext,
    feed: ICombinedFeedView,
    userIsMember: boolean,
  ): ITool[];
}

export class ToolService implements IToolService {
  private pageContext: IVssPageContext;
  private pageData?: IPageData;

  private static registeredTools: ITool[] = [];

  public constructor(pageContext: IVssPageContext) {
    this.pageContext = pageContext;
    this.pageData = pageContext.getService<IVssPageService>("IVssPageService").getData();
  }

  // TODO: add ordering parameter
  public static registerTool(tool: ITool): void {
    ToolService.registeredTools.push(tool);
    ToolService.registeredTools.sort((a, b) => a.id - b.id);
  }

  private isToolEnabled = (
    pageContext: IVssPageContext,
    feed: ICombinedFeedView,
    tool: ITool,
    userIsMember: boolean,
  ): boolean => {
    const isEnvironmentSupported = this.pageData
      ? tool.isEnvironmentSupported(this.pageData)
      : true;
    const protocolAvailable = tool.isProtocolEnabled(pageContext);
    const hasValidAction = tool.supportsGet() || tool.supportsPush(feed);
    const visibleToUser = userIsMember || tool.allowNonMembers;

    return protocolAvailable && isEnvironmentSupported && hasValidAction && visibleToUser;
  };

  public getAvailableTools(
    pageContext: IVssPageContext,
    feed: ICombinedFeedView,
    userIsMember: boolean,
  ): ITool[] {
    return ToolService.registeredTools.filter((tool) =>
      this.isToolEnabled(pageContext, feed, tool, userIsMember),
    );
  }
}
